import { ENTERPRISE_API } from '../config/constants/env'
import axios, { Method } from 'axios'
import { get } from 'lodash'
import ISubmissionLinkVerifiedEmailView from 'types/ISubmissionLinkVerifiedEmailView'

export default class EnterpriseRequests {
  static buildRequest(args: { enterpriseId: string; url: string; method?: Method }) {
    return {
      headers: {
        accept: 'application/json',
        'Content-Type': 'application/json',
        'X-Client-Type': 'Enterprise'
      },
      baseURL: ENTERPRISE_API.BASE_URL.replace('ENTERPRISE_ID', args.enterpriseId),
      method: args.method || 'GET',
      url: args.url
    }
  }

  static async validateSubmissionLink(
    enterpriseId: string,
    code: string,
    email: string
  ): Promise<[ISubmissionLinkVerifiedEmailView | null, number, string | null]> {
    const requestConfig = EnterpriseRequests.buildRequest({
      enterpriseId,
      url: `/initiatives/submission-links/${code}/verify-email/${email}`,
      method: 'GET'
    })

    try {
      const response = await axios(requestConfig)

      return [response.data as ISubmissionLinkVerifiedEmailView, response.status, null]
    } catch (error) {
      if (error.response) {
        const errorMessage = [404, 500].includes(error.response.status)
          ? error.message
          : get(error, 'response.data') || error.message
        return [null, error.response.status, errorMessage]
      }

      return [null, 0, error.message]
    }
  }
}
